import { post } from '../utility';

export const getStatus = ({ callback }) => {
	post({
		method: 'tankDailySalesStatus.get',
		params: {},
		callback,
	});
};

export const searchDaily = ({ startDate, endDate, lookbackDays, callback }) => {
	post({
		method: 'tankDailySalesStatus.daily.search',
		params: { startDate, endDate, lookbackDays },
		callback,
	});
};
